import React, {useEffect, useState} from "react";
import {getCodeFromLocation} from "./helpers/getCodeFromLocation";
import {getVerifierState} from "./helpers/getVerifierState";
import {fetchToken} from "./helpers/fetchToken";
import {removeCodeFromLocation} from "./helpers/removeCodeFromLocation";
import {removeStateFromStorage} from "./helpers/removeStateFromStorage";
import AuthenticationContext from "./auth-context";
import authorize from "./helpers/authorize";

export interface AuthenticationProviderOptions {
    children?: React.ReactNode;
    clientId?: string;
    clientSecret?: string;
    provider?: string;
    authorizationEndpoint?: string;
    tokenEndpoint?: string;
    redirectUri?: string;
}

const AuthenticationProvider = (opts: AuthenticationProviderOptions): JSX.Element => {

    const {
        children,
        clientId,
        clientSecret,
        provider,
        authorizationEndpoint,
        tokenEndpoint,
        redirectUri
    } = opts;

    const [token, setToken] = useState();
    const storage = sessionStorage;
    const scopes: string[] = ['openid', 'profile', 'groups', 'email'];

    useEffect(() => {
        if (!token) {
            const code = getCodeFromLocation({location: window.location});
            const state = getVerifierState({clientId, storage});
            if (code && state) {
                fetchToken({
                    clientId, clientSecret, tokenEndpoint, code, state, fetch
                })
                    .then(t => {
                        localStorage.setItem('pfJwt', t['access_token']);
                        setToken(t);
                    })
                    .then(() => {
                        removeCodeFromLocation();
                        removeStateFromStorage({clientId, storage});
                    })
                    .catch(e => {
                        console.error(e);
                        alert(`Error fetching auth token: ${e.message}`);
                    })
            }
        }
    }, [token]);

    const checkAuth = () => {
        const code = getCodeFromLocation({location: window.location})
        if (!token && !code) {
            authorize({redirectUri, provider, authorizationEndpoint, clientId, scopes});
        }
    }

    return (
        <AuthenticationContext.Provider value={{token, checkAuth: checkAuth}}>
            {children}
        </AuthenticationContext.Provider>
    );
}

export default AuthenticationProvider;
